import Employee from "./employee"

export enum PermissionTypeName {
    Read = "Read",
    Edit = "Edit",
    Admin = "Admin",
    Owner = "Owner",
}

export interface EmployeeDepartmentPermissionType {
    id: string
    name: string
}

export default interface EmployeeDepartmentPermission {
    id: string
    employeeId: string
    departmentId: string
    permissionTypeId: string
    revoked: boolean
    revokedAt?: Date | null
    createdById: string
    revokedById?: string | null
    createdAt?: Date
    updatedAt?: Date

    employee?: Employee
    permissionType?: EmployeeDepartmentPermissionType
}
